module.exports = __webpack_public_path__ + "img/1440.354838b1.jpg";